import { ActivityLog } from '../types';

const filterActivityLogs = (value: string, logs: ActivityLog[]): ActivityLog[] => {
  if (!value) return logs;

  const lowerInput = value.toLowerCase();
  return logs.filter(
    (log) =>
      log.Title?.toLowerCase().includes(lowerInput) ||
      log.CustomerName?.toLowerCase().includes(lowerInput) ||
      log.ConsultantName?.toLowerCase().includes(lowerInput) ||
      log.StatusTitle?.toLowerCase().includes(lowerInput) ||
      log.Description?.toLowerCase().includes(lowerInput),
  );
};

export default filterActivityLogs;
